module.exports = __webpack_public_path__ + "static/media/index-bg08-03.76bda105.jpg";